<template>
  <div class="flex items-center" v-if="phase">
    <div class="w-2 h-2 rounded-full mr-2" :class="dotColor"></div>
    <div>{{ phase.name }}</div>
  </div>
</template>

<script>
const POTENTIAL_COLORS = [
  "bg-orange-300",
  "bg-orange-400",
  "bg-orange-500",
  "bg-orange-600",
  "bg-orange-700",
  "bg-orange-800"
];

export default {
  props: {
    phase: {
      type: Object,
      required: true
    }
  },

  computed: {
    dotColor() {
      let position = this.phase.position;
      if (position > 5) position = 5;
      return POTENTIAL_COLORS[position];
    }
  }
};
</script>